var map = {
	"./v2-home-certificates.svg": 3037,
	"./v2-home-channels.svg": 3038,
	"./v2-home-clp.svg": 3039,
	"./v2-home-courses.svg": 3040,
	"./v2-home-exams.svg": 3041,
	"./v2-home-gamification.svg": 3042,
	"./v2-home-leaderboard.svg": 3043,
	"./v2-home-projects.svg": 3044,
	"./v2-home-resume.svg": 3045
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3036;